import React from 'react';
import { connect } from 'react-redux';
import { createWeekNumbers } from '../calendarHelper';
import '../Calendar.css'
import CreateDaysHeader from './CreateDaysHeader.jsx';
import CreateDay from "./CreateDay.jsx";

class CreateMonth extends React.PureComponent {
  render() {
    let loading = null;
    if (this.props.fetching) {
      loading = (
        <div className="col-12 p-5 text-center IsLoadingCalendar--loading">
          <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
          <span className="">Loading&hellip;</span>
        </div>
      );
    }
    const tempDaysforMonth = this.props.firstDayOfMonth + this.props.daysInMonth;
    const weeksInMonths = Math.ceil(tempDaysforMonth / 7);
    const weeks = createWeekNumbers(this.props.prevMonthDays, this.props.firstDayOfMonth, this.props.daysInMonth, weeksInMonths, this.props.month, this.props.year);
    return (
      <div className="month position-relative">
        {loading? <div className='IsLoadingCalendar'>
          {loading}
        </div>
          : null}
        <CreateDaysHeader />
        {
          weeks.map((weekVals, idx) => {
            return (
              <div key={`week-${idx}`} className="week row">
                {
                  weekVals.map((day) => <CreateDay key={`day-${day}`} day={day} />)
                }
              </div>
            );
          })
        }
      </div>
    );
  }
}

const mapStateToProps = state => ({
  error: state.calendarEvents.error,
  fetching: state.calendarEvents.fetching,
  month: state.calendarEvents.month,
  year: state.calendarEvents.year,
});

export default connect(mapStateToProps)(CreateMonth);